module.exports = __webpack_public_path__ + "img/pickup.8d65db17.svg";